import { Usuario } from './../../models/usuario.model';
import { ModalResetPasswordComponent } from './../../components/modal-reset-password/modal-reset-password.component';
import { LoadingService } from './../../services/loading.service';
import { HelperService } from './../../services/helper.service';
import { AuthService } from './../../services/auth.service';
import { NgForm } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  user: any = {};
  isLogin: boolean = true;

  constructor(
    public auth: AuthService,
    public helper: HelperService,
    public loadingService: LoadingService,
    public router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  login(f: NgForm) {
    if (f.invalid) {
      this.helper.formMarkAllTouched(f);
      return;
    }

    this.loadingService.present('Fazendo o login, aguarde...');

    // A API responde 200 mesmo quando as credenciais estao erradas: quem diz e o campo `auth`.
    this.auth.login(this.user).subscribe((res: any) => {
      if (res && res.auth && res.token) {
        // o token precisa estar no service antes do getUser, que ja vai autenticado
        this.auth.setToken(res.token);

        this.auth.getUser(this.user).then((r: Usuario) => {
          if (r && r.solicitaAlteracao == 'S') {
            // a troca de senha na API nova exige um codigo enviado por e-mail
            this.auth.isRecuperarSenha = true;
            this.auth.forgotPassword(this.user)
              .then(() => this.abrirModalNovaSenha())
              .catch(() => this.helper.openSnackBar('Nao foi possivel enviar o codigo de verificacao.'));
          } else {
            this.router.navigate(['/']);
          }
          this.loadingService.dismiss()
          this.auth.setUser(r);
        }, e => {
          this.helper.openSnackBar(e.error);
          this.loadingService.dismiss()
        });
      } else {
        this.helper.openSnackBar((res && res.message) ? res.message : 'Nao foi possivel entrar.');
        this.loadingService.dismiss();
      }
    }, e => {
      this.helper.openSnackBar(e.error);
      this.loadingService.dismiss()
    });
  }

  esqueceuSenha(f: NgForm) {
    if (f.invalid) {
      this.helper.formMarkAllTouched(f);
      this.helper.openSnackBar('Preencha o formulário corretamente');
      return;
    }

    this.loadingService.present('Recuperando senha...');

    const email = this.user.email;

    this.auth.forgotPassword(this.user).then((res: any) => {
      this.helper.openSnackBar('Verifique sua caixa de entrada. Enviamos o codigo de verificacao.');
      f.reset();
      this.loadingService.dismiss();
      this.abrirModalNovaSenha(email);
    }).catch((e) => {
      this.helper.openSnackBar(e.error);
      this.loadingService.dismiss();
    })
  }

  // O modal pede o codigo recebido por e-mail junto com a nova senha.
  abrirModalNovaSenha(email?: string) {
    const dialogRef = this.dialog.open(ModalResetPasswordComponent, {
      width: '420px',
      data: { email: email || this.user.email }
    });

    dialogRef.afterClosed().subscribe(alterada => {
      if (alterada) {
        this.isLogin = true;
        this.helper.openSnackBar('Senha alterada. Faca o login com a nova senha.');
      }
    });
  }

}
